import React from 'react';
import Joi from 'joi-browser';
import * as _ from 'lodash';
import { validationByJoi } from '../utilities/commonValidation';

import { Edited } from './modals/Commons';
import dialogLoader from '../utilities/dialogLoader';

import { FieldApprovalsService } from '../services/FieldApprovals';

import Helmet from 'react-helmet';
import { HEADER_CONSTANTS } from '../utilities/constants';
import { deleteControlCode } from '../utilities/stringUtil';

export class FieldApprovals extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      fieldId: sessionStorage.getItem('field_id'),
      fieldApprovals: [],
      errors: {},
    };

    this.formKeys = {
      id: null,
      name: '',
      short_name: '',
      approval_level: 1,
      signature_number: 0,
      approval_group: 0,
    };

    this.events = {
      table: {
        onChangeFieldApproval: this.onChangeFieldApproval.bind(this),
        onChangeFieldApprovalRadio: this.onChangeFieldApprovalRadio.bind(this),
        validate: this.validate.bind(this),
      },
      form: {
        submit: this.eventSubmit.bind(this),
      },
    };

    this.schema = Joi.object().keys({
      id: Joi.allow(),
      name: Joi.string().allow(),
      short_name: Joi.string()
        .max(32)
        .required(),
      approval_level: Joi.number().required(),
      signature_number: Joi.number().required(),
      approval_group: Joi.number().required(),
    });
  }

  componentDidMount() {
    this.setFieldApproval();
  }

  setFieldApproval() {
    const fieldId = this.state.fieldId;
    FieldApprovalsService.list(fieldId).then(resp => {
      if (resp.result) {
        const fieldApprovals = resp.data.entities.field_approvals;
        _.each(fieldApprovals, (fieldApproval, index) => {
          const formValues = {};
          _.each(Object.keys(this.formKeys), key => {
            formValues[key] = fieldApproval[key];
          });
          fieldApprovals[index] = formValues;
        });
        this.setState({ fieldApprovals });
      }
    });
  }

  onChangeFieldApproval = (e, index) => {
    const fieldApprovals = _.cloneDeep(this.state.fieldApprovals);
    fieldApprovals[index][e.target.name] = deleteControlCode(e.target.value);
    this.setState({
      fieldApprovals,
    });
  };

  onChangeFieldApprovalRadio = (index, name, value) => {
    const fieldApprovals = this.state.fieldApprovals;
    fieldApprovals[index][name] = value;
    this.setState({
      fieldApprovals,
    });
  };

  //バリデーション
  validate(index) {
    const fieldApprovals = this.state.fieldApprovals;
    let errors = this.state.errors;
    if (index >= 0) {
      const result = validationByJoi(this.schema, fieldApprovals[index]);
      if (!result.status) {
        errors[index] = result.messages.short_name;
      } else {
        delete errors[index];
      }
    }
    this.setState({ errors });
  }

  eventSubmit = () => {
    if (Object.keys(this.state.errors).length !== 0) {
      return;
    }
    const fieldId = this.state.fieldId;
    const params = { field_approvals: this.state.fieldApprovals };
    FieldApprovalsService.create(fieldId, params).then(resp => {
      if (resp.result) {
        dialogLoader.show(Edited);
        this.setFieldApproval();
      }
    });
  };

  render() {
    const getErrorMessage = (errors, index) => {
      if (errors[index]) {
        return <div className='validate-message show'>{errors[index]}</div>;
      } else {
        return null;
      }
    };

    return (
      <div id='main__body1' className='setting-main__body'>
        <Helmet>
          <title>{HEADER_CONSTANTS.conference} - 承認権限設定</title>
        </Helmet>
        <div id='setting-header' className='approval-setting-header'>
          <div className='approval-setting-header__item'>
            <button
              className='btn--effective'
              onClick={this.events.form.submit}
            >
              更新
            </button>
          </div>
        </div>
        <div className='setting-main__table'>
          <table id='table' className='setting-table'>
            <thead
              id='table-label'
              className='setting-table__header'
              style={{ position: 'relative', top: 'auto', width: 'auto' }}
            >
              <tr className='setting-table__label'>
                <td className='approval-setting-value-table__item sys-sort-toggle'>
                  レベル※1
                </td>
                <td className='approval-setting-value-table__name sys-sort-toggle'>
                  権限略称※2
                </td>
                <td className='approval-setting-value-table__item sys-sort-toggle'>
                  押印個数※3
                </td>
                <td className='approval-setting-value-table__radio sys-sort-toggle'>
                  承認グループ※4
                </td>
              </tr>
            </thead>
            <tbody id='table-body'>
              {this.state.fieldApprovals.map((fieldApproval, index) => (
                <tr key={index} className='setting-table__item'>
                  <td className='approval-setting-value-table__item'>{`レベル${
                    fieldApproval.approval_level
                  }`}</td>
                  <td className='approval-setting-value-table__name'>
                    <span className='label'>権限略称</span>
                    <input
                      type='text'
                      name='short_name'
                      value={fieldApproval.short_name}
                      maxLength={32}
                      onChange={e => {
                        this.events.table.onChangeFieldApproval(e, index);
                      }}
                      onBlur={() => this.events.table.validate(index)}
                    />
                    {getErrorMessage(this.state.errors, index)}
                  </td>
                  <td className='approval-setting-value-table__item'>
                    <span className='label'>押印個数</span>
                    <select
                      name='signature_number'
                      value={fieldApproval.signature_number}
                      onChange={e => {
                        this.events.table.onChangeFieldApproval(e, index);
                      }}
                    >
                      <option value='1'>1</option>
                      <option value='2'>2</option>
                      <option value='3'>3</option>
                      <option value='4'>4</option>
                      <option value='5'>5</option>
                    </select>
                  </td>
                  <td className='approval-setting-value-table__radio'>
                    <span className='label'>承認グループ</span>
                    <label
                      htmlFor={`approval_group_${index}_1`}
                      className='radio'
                    >
                      <input
                        type='radio'
                        id={`approval_group_${index}_1`}
                        name={`approval_group_${index}_1`}
                        readOnly
                        checked={fieldApproval.approval_group === 1}
                        onClick={() => {
                          this.events.table.onChangeFieldApprovalRadio(
                            index,
                            'approval_group',
                            1
                          );
                        }}
                      />
                      <i className='i-circle i-3x' aria-hidden='true' />A
                    </label>
                    <label
                      htmlFor={`approval_group_${index}_2`}
                      className='radio'
                    >
                      <input
                        type='radio'
                        id={`approval_group_${index}_2`}
                        name={`approval_group_${index}_2`}
                        readOnly
                        checked={fieldApproval.approval_group === 2}
                        onClick={() => {
                          this.events.table.onChangeFieldApprovalRadio(
                            index,
                            'approval_group',
                            2
                          );
                        }}
                      />
                      <i className='i-circle i-3x' aria-hidden='true' />B
                    </label>
                    <label
                      htmlFor={`approval_group_${index}_3`}
                      className='radio'
                    >
                      <input
                        type='radio'
                        id={`approval_group_${index}_3`}
                        name={`approval_group_${index}_3`}
                        readOnly
                        checked={fieldApproval.approval_group === 3}
                        onClick={() => {
                          this.events.table.onChangeFieldApprovalRadio(
                            index,
                            'approval_group',
                            3
                          );
                        }}
                      />
                      <i className='i-circle i-3x' aria-hidden='true' />C
                    </label>
                    <label
                      htmlFor={`approval_group_${index}_4`}
                      className='radio'
                    >
                      <input
                        type='radio'
                        id={`approval_group_${index}_4`}
                        name={`approval_group_${index}_4`}
                        readOnly
                        checked={fieldApproval.approval_group === 4}
                        onClick={() => {
                          this.events.table.onChangeFieldApprovalRadio(
                            index,
                            'approval_group',
                            4
                          );
                        }}
                      />
                      <i className='i-circle i-3x' aria-hidden='true' />D
                    </label>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          <div className='setting-table-description'>
            <div className='setting-table-description__item'>
              ※1 レベル1【高】&gt; レベル4【低】
            </div>
            <div className='setting-table-description__item'>
              ※2 作業一覧承認欄名称及び作業指示書の押印欄名称に使用されます
            </div>
            <div className='setting-table-description__item'>
              ※3 作業一覧での押印欄の数となります
            </div>
            <div className='setting-table-description__item'>
              ※4 A【高】&gt; D【低】
              同一又は下位の権限者の承認のみ解除可能です（上位の権限者の承認解除は不可）
            </div>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/FieldApprovals.jsx